import { calculateDistance } from '../../api/LocationFunctions';
import numberFormat from "../../api/NumberFormat";
import LiveChatClass from '../../../live-chat/modules/live-chat-class';

const state = {
    dealers: [],
    lat: false,
    lng: false,
    locationString: '',
    haveLocation: false,
    geoLocation: false,
    loading: true,
    initialized: false,
    selectedDealer: {},
    closedDays: [],
};

const getters = {
    initialized(state) {
        return state.initialized;
    },

    dealers(state) {
        return state.dealers;
    },

    geoLocation(state) {
        return state.geoLocation;
    },

    closedDays(state) {
        return state.closedDays;
    },

    maxDate(state) {
        return state.selectedDealer.maxDate;
    },

    minDate(state) {
        return state.selectedDealer.minDate;
    },
};

const actions = {
    getDealers({ commit }, options) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            let getAddressInfo = false;
            let getPhoneInfo = false;
            if (typeof options != 'undefined') {
                if (typeof options.getAddressInfo != 'undefined' && options.getAddressInfo == true) {
                    getAddressInfo = true;
                }
                if (typeof options.getPhoneInfo != 'undefined' && options.getPhoneInfo == true) {
                    getPhoneInfo = true;
                }
            }

            window.LocationDataLoader.get(getAddressInfo, getPhoneInfo)
                .then(dealers => {
                    commit('setLoading', false);
                    commit('setDealers', dealers);
                    resolve(dealers);
                })
                .catch((error) => {
                    commit('setLoading', false);
                    commit('setDealers', []);
                    reject(error);
                });
        });
    },
    setDistances({ dispatch, commit, state, rootState }) {
        return new Promise((resolve, reject) => {
            if (state.haveLocation) {
                commit('setDealersWithDistance');
                resolve();
                return;
            }

            commit('setDealers', state.dealers.map((dealer) => {
                dealer.distance = null;
                dealer.name_with_distance = null;
                return dealer;
            }));

            resolve();
        });
    },
    // Function to initialize the store, loading in localStorage values if they exist
    initializeLocation({commit, dispatch, state}, options) {
        return new Promise((resolve, reject) => {
            // If we've already done the init, return early
            if (state.initialized) {
                resolve({
                    firstLoad: false,
                    haveLocation: state.haveLocation
                });
                return;
            }
            commit('setInitialized', true);

            // Collect the dealers from the API
            dispatch('getDealers', options)
                .then(dealers => {
                    // Once the dealers are loaded, check if we have a stored location
                    let previousLocation = localStorage.getItem('customerLocation');
                    if (previousLocation == '' || previousLocation == null) {
                        resolve({
                            firstLoad: false,
                            haveLocation: false,
                        });
                        return;
                    }
                    previousLocation = JSON.parse(previousLocation);
                    commit('setLocationWithoutStoring', previousLocation);
                    dispatch('setDistances').then(() => {
                        resolve({
                            firstLoad: true,
                            haveLocation: state.haveLocation
                        });
                    })
                })
                .catch((error) => {
                    console.error('resources/assets/js/used-vue/store/modules/dealers.js@initializeLocation', error);
                    reject(error);
                });
        });
    },

    getClosedDays({ commit, state }, serviceType) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/dealer-closed-days?dealer=${state.selectedDealer.id}&service_type=${serviceType}`)
                .then(response => {
                    commit('setClosedDays', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getFirstBookableDate({ commit, state }, serviceType) {
        return new Promise((resolve, reject) => {
            axios({
                method: "GET",
                url: "/api/dealer-first-bookable-date",
                params: {
                    location: state.selectedDealer.id,
                    service_type: serviceType,
                    lead_time: null,
                },
            })
            .then(response => {
                const minDate = new Date(Date.parse(response.data));
                commit('setMinDate', minDate);
                resolve(minDate);
            })
            .catch((error) => {
                const defaultDate = new Date();
                defaultDate.fp_incr(2); 
                commit('setMinDate', defaultDate);
                resolve();
            });
        });
    },

    setSelectedTime({ commit }, time) {
        commit('setSelectedTime', time);
    },
};

const mutations = {
    setInitialized(state, value) {
        state.initialized = value;
    },
    setDealers(state, dealers) {
        state.dealers = JSON.parse(JSON.stringify(dealers));
        if (!window.liveChatClass) {
            window.liveChatClass = new LiveChatClass({
                redesign: true
            });
        }
    },
    setDealersWithDistance(state) {
        for (let index = 0, len = state.dealers.length; index < len; index++) {
            const dealer = state.dealers[index];

            if (dealer.is_national_centre == 1) {
                state.dealers[index].distance = 100000;
                state.dealers[index].name_with_distance = dealer.name;
            } else {
                state.dealers[index].distance = calculateDistance(dealer.lat, dealer.lng, state.lat, state.lng);
                state.dealers[index].name_with_distance = dealer.name + ' - ' + numberFormat(dealer.distance, 0) + ' miles away';
            }
        }

        state.dealers.sort((dealer1, dealer2) => {
            if (dealer1.distance < dealer2.distance) {
                return -1;
            }
            if (dealer1.distance > dealer2.distance) {
                return 1;
            }
            return 0;
        });

        if (!window.liveChatClass) {
            window.liveChatClass = new LiveChatClass({
                redesign: true
            });
        }
    },
    setLocation(state, location) {
        state.lat = location.lat;
        state.lng = location.lng;
        state.haveLocation = true;

        if (location.locationString) {
            state.locationString = location.locationString;
        }

        if (typeof localStorage == 'undefined') {
            return;
        }
        localStorage.setItem('customerLocation', JSON.stringify({
            lat: state.lat,
            lng: state.lng,
            geoLocation: false,
            locationString: state.locationString,
        }));
    },
    // Updates the location state without re-triggering the storage. Used when initializing the state of the store.
    setLocationWithoutStoring(state, location) {
        if (location.lat && location.lng) {
            state.lat = location.lat;
            state.lng = location.lng;
            state.haveLocation = true;
        }
        if (location.geoLocation) {
            state.geoLocation = (location.geoLocation == true) ? location.geoLocation : false;
        }
        if (location.locationString) {
            state.locationString = location.locationString;
        }
    },
    setLoading(state, value) {
        state.loading = value;
    },
    setGeoLocation(state, position) {
        state.lat = position.coords.latitude;
        state.lng = position.coords.longitude;
        state.geoLocation = true;
        state.haveLocation = true;
        state.locationString = 'My Location';

        // If we have localStorage access, update it to use geolocation
        if (typeof localStorage == 'undefined') {
            return;
        }
        localStorage.setItem('customerLocation', JSON.stringify({
            lat: state.lat,
            lng: state.lng,
            geoLocation: true,
            locationString: state.locationString,
        }));
    },

    setSelectedDealer(state, dealer) {
        state.selectedDealer = dealer
    },

    setClosedDays(state, closedDays) {
        state.closedDays = closedDays.map(closedDay => new Date(closedDay));
    },

    setMinDate(state, date) {
        state.selectedDealer.minDate = date;
    },
    
    setMaxDate(state, maxDate) {
        state.selectedDealer.maxDate = maxDate;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};